import React from 'react';

import {connect} from "react-redux"//联系store的组件
import evn from "./../../../../../actions/index"//action的所有事件

import "./style.css"//引入样式
import { Radio, Modal, Form, Input, message} from 'antd';//引入antd组件
import { Hcurl } from "./../../../../../constants/index"//获取公共路径
import Event from "./../../../../../assets/PubJs/hcPub"//所有事件
import EventSet from "./../../../../../assets/PubJs/hcPub"//所有事件
import $ from "jquery"
import createHistory from 'history/createHashHistory';//路由切换地址
import { setTimeout } from 'core-js/library/web/timers';
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const history = createHistory();//定义history路由


//切换企业组件
let _BindCompany=null;
class BindCompany extends React.Component {
    state = {
        value: Event.getUserInfo().UCR_ComID,
        list:[]
    };
    componentDidMount() {
        _BindCompany = this;
    }
    componentWillMount(){
        _BindCompany = this;
    }
    //公司选择
    onRadioChange = (e) => {
        this.setState({
            value: e.target.value,
        });
    };

    //提交数据
    returnData(){
        let setData = {
            UserCode: Event.getUserInfo().CU_Code,
            CompanyCode: _BindCompany.state.value,
            Type: "0",
        };
        $.ajax({
            url: Hcurl+"/CompanyCore/AddCompany",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                if (res.split("|")[0] == "false") {
                    message.error(res.split("|")[1]);
                    _App.setState({
                        confirmLoading: false,
                    });
                } else {
                    let userInfo = JSON.parse(localStorage.userInfo);
                    userInfo.UCR_ComID = res.split("|")[1];
                    userInfo.Com_Name = res.split("|")[2];
                    userInfo.UCR_IsAdmin = res.split("|")[3];
                    localStorage.setItem("userInfo", JSON.stringify(userInfo))
                    history.push({
                        pathname: "/Content/Business/CompanyList/test",
                    })
                    _App.props.dispatch(evn.closeModal())
                    _App.props.dispatch(evn.changeTagKey("1"))
                    _App.setState({
                        confirmLoading: false,
                    });
                }
            },
            error: function (data, err) {
                _App.setState({
                    confirmLoading: false,
                });
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }

    //组件完成
    componentDidMount(){
        _BindCompany = this;
    }

    //组件渲染
    render() {
        return (
            <div className={"CompanyModal_radioGroupList"}>
                <p>单击下方企业名称进行切换</p>
                <RadioGroup onChange={this.onRadioChange} value={this.state.value}>
                    {
                        this.state.list.map(function (e) {
                            return < Radio key={e.Com_Code} value = { e.Com_Code} > { e.Com_Name}</Radio>
                        })
                    }
                </RadioGroup>
            </div>
        )
    }
}


let _App = null;
class App extends React.Component {
    state={
        confirmLoading: false,
    };

    //点击确定事件
    handleOk = (e) => {
        this.setState({
            confirmLoading: true,
        });
        _BindCompany.returnData()
    };

    componentWillReceiveProps(e) {
        _App.setState({
            confirmLoading: false,
        });
        if (e.visible) {
            let setData = {
                UserCode: Event.getUserInfo().CU_Code,
            };
            $.ajax({
                url: Hcurl + "/CompanyCore/GetSelectCompany",
                type: "post",
                data: setData,
                async: false,
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (res) {
                    setTimeout(function () {
                        _BindCompany.setState({
                            list: JSON.parse(res)
                        })
                    }, 10)
                },
                error: function (data, err) {
                    if (!JSON.parse(data.responseText).success && data.status === 403) {
                        history.push({ "pathname": "/err" })
                    } else {
                        message.error(err)
                    }
                }
            })
        }
    }

    //点击取消事件
    handleCancel = (e) => {
        _BindCompany.setState({
            value:Event.getUserInfo().UCR_ComID
        })
        this.props.dispatch({ type:"closeModalCom"})
    };


    //组件完成
    componentDidMount() {
        _App=this
    }
    //渲染组件
    render() {
        return (
            <div id="CompanyModal">
                <Modal
                    title={"切换企业"}
                    visible={this.props.visible}
                    onOk={this.handleOk}
                    okText={"确定"}
                    cancelText={"取消"}
                    onCancel={this.handleCancel}
                    confirmLoading={this.state.confirmLoading}
                >
                    <BindCompany />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // console.log(state.ChangeCompanyModal,"123123")
    // 判断企业选择框是否显示
    return {
        visible: state.ChangeCompanyModal.isVisible,
    }
};
export default connect(mapStateToProps)(App)


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyCenter/CompanyModal/changeCom.js